<script>
import { mapState, mapGetters } from "vuex";

import Header from "./OrderComponents/Header";
import OrderDetails from "./OrderComponents/OrderDetails";
import Coupon from "./OrderComponents/Coupon";
import Total from "./OrderComponents/Total";
import AccountBalance from "./OrderComponents/AccountBalance";
import AccountBonus from "./OrderComponents/AccountBonus";

export default {
  components: {
    Header,
    OrderDetails,
    Coupon,
    Total,
    AccountBalance,
    AccountBonus
  },

  computed: {
    ...mapState("payable", ["accountBalance", "accountBonus"]),

    ...mapGetters("payable", [
      "canShowCouponPart",
      "canPayWithAccountBalance",
      "canPayWithAccountBonus"
    ]),
    ...mapGetters("user", ["accountBalanceAvailable", "accountBonusAvailable"])
  }
};
</script>

<template>
  <div>
    <Header />
    <OrderDetails />
    <Coupon v-if="canShowCouponPart" />
    <AccountBalance v-if="accountBalanceAvailable" />
    <AccountBonus v-if="accountBonusAvailable" />
    <Total />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payable/Order.vue